

// import React, { useEffect, useState, useMemo } from "react";
// import useHttp from "../../../../hook/use-http";
// import { Chart } from "react-google-charts";
// import NoData from "../../NoData";
// import ChartLoader from "../../ChartLoader";
// import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
// import WaterMark from "../../DashboardMain_Orion/WaterMark";
// import { BsZoomIn } from "react-icons/bs";
// import { Bar } from "react-chartjs-2";
// import CommanBarTable_Orion from "../CommanBarTable_Orion";

// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// let CoolantChartData;

// function CoolantInCycles_Orion({
//   apiend,
//   gloablfilter,
//   type,
//   coolantin_Option,
//   chartnameFCD,
//   selectedPack = "A",
//   coolantInOut = "In"
// }) {
//   const MAIN_ENDPOINT = "orion_charging_analysis/";
//   const CLICK_ENDPOINT = "coolant_in_cycles_click";

//   const [chartdata, setChartData] = useState([]);
//   const { isLoading, sendReq: fetchData } = useHttp();
//   const [chartname, SetChartName] = useState(chartnameFCD);
//   const [tempCoolant, setTempCoolant] = useState("");

//   let barcolor = "#3578b0";

//   // Compose coolant option
//   const composedCoolantOption = useMemo(() => {
//     if (coolantin_Option && coolantin_Option.trim() !== "") {
//       return coolantin_Option;
//     }
//     return `${selectedPack}_Coolant_Temp_${coolantInOut}`;
//   }, [coolantin_Option, selectedPack, coolantInOut]);

//   // ---------------------------------------------------------
//   // BIN LABELS
//   // ---------------------------------------------------------
//   const binLabels = [
//     "<20",
//     "20–24",
//     "24–28",
//     "28–32",
//     "32–36",
//     "36–40",
//     "40–44",
//     "44–48",
//     ">48"
//   ];

//   // ---------------------------------------------------------
//   // 🔥 BIN RANGES ADDED (CLICK PAYLOAD)
//   // ---------------------------------------------------------
//   const binRanges = [
//     { from: 0, to: 20 },
//     { from: 20, to: 24 },
//     { from: 24, to: 28 },
//     { from: 28, to: 32 },
//     { from: 32, to: 36 },
//     { from: 36, to: 40 },
//     { from: 40, to: 44 },
//     { from: 44, to: 48 },
//     { from: 48, to: 9999 }
//   ];

//   // =====================================================
//   // MAIN DATA PROCESSING
//   // =====================================================
//   const appyDataCycles = (data) => {
//     if (!data || data.length === 0) {
//       setChartData([]);
//       return;
//     }

//     let d = data[0];
//     let keys = Object.keys(d).filter((k) => k.startsWith("B"));

//     let googleChartArr = [["Element", "Count", { role: "style" }]];
//     let labels = [];
//     let datasetValues = [];

//     keys.forEach((k, index) => {
//       let label = binLabels[index] || k;

//       let value =
//         d[k] && typeof d[k].value === "number"
//           ? d[k].value
//           : (d[k] && d[k].value) || 0;

//       labels.push(label);
//       datasetValues.push(value);

//       googleChartArr.push([
//         label,
//         value,
//         "stroke-width: 1;stroke-color: black;"
//       ]);
//     });

//     CoolantChartData = {
//       labels,
//       datasets: [
//         {
//           label: "Coolant Values",
//           data: datasetValues,
//           backgroundColor: barcolor,
//           borderWidth: 1,
//           borderColor: "black"
//         }
//       ]
//     };

//     setChartData(googleChartArr);
//   };

//   const options1 = {
//     responsive: true,
//     categoryPercentage: 1.0,
//     barPercentage: 1.0,
//     scales: {
//       x: {
//         grid: { color: "white" },
//         title: { display: true, text: "Coolant Temperature" },
//         ticks: { autoSkip: false }
//       },
//       y: {
//         grid: { color: "white" },
//         title: { display: true, text: "Charging Cycles" }
//       }
//     },
//     plugins: { legend: { display: false } }
//   };

//   const options = {
//     hAxis: {
//       gridlines: { color: "transparent" },
//       title: "Coolant Temperature",
//       slantedText: true,
//       slantedTextAngle: 90
//     },
//     vAxis: {
//       gridlines: { color: "transparent" },
//       title: "Charging Cycles"
//     },
//     bar: { groupWidth: "100%" },
//     legend: "none",
//     series: { 0: { color: "#3578b0" } }
//   };

//   useEffect(() => {
//     setTempCoolant(composedCoolantOption);

//     fetchData(
//       {
//         url: API_URL_MAIN + MAIN_ENDPOINT + apiend,
//         body: {
//           filterdata: gloablfilter,
//           coolantin_Option: composedCoolantOption
//         }
//       },
//       appyDataCycles
//     );

//     SetChartName(chartnameFCD || `Coolant Cycles - ${composedCoolantOption}`);
//   }, [gloablfilter, type, composedCoolantOption, apiend]);

//   // =====================================================
//   // CLICK POPUP LOGIC
//   // =====================================================
//   const [toPushPopUp, settoPushPopUp] = useState([]);

//   const appyDataClick = (data) => {
//     let arr = [];

//     data.forEach((i) => {
//       arr.push({
//         key: {
//           vehicleId: i.key.vehicleId,
//           Depot_Name: i.key.Depot_Name,
//           DLR_ORG_CITY: i.key.DLR_ORG_CITY,
//           vehicle_registration_number: i.key.vehicle_registration_number
//         },
//         doc_count: i.doc_count,
//         [tempCoolant]: {
//           values: {
//             "50.0": i.doc_count
//           }
//         }
//       });
//     });

//     arr.sort((a, b) => {
//       const av =
//         a[tempCoolant]?.values?.["50.0"] || 0;
//       const bv =
//         b[tempCoolant]?.values?.["50.0"] || 0;
//       return bv - av;
//     });

//     settoPushPopUp(arr);
//   };

//   return (
//     <>
//       {/* MODAL CHART */}
//       <div className="modal fade" id={apiend + "_modal"} tabIndex={-1}>
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" />
//             </div>

//             <div
//               className="modal-body d-flex justify-content-center"
//               style={{ height: "400px" }}
//             >
//               {isLoading ? (
//                 <ChartLoader />
//               ) : chartdata.length > 1 ? (
//                 <Bar
//                   options={options1}
//                   data={CoolantChartData}
//                   width="100%"
//                   height="65px"
//                 />
//               ) : (
//                 <NoData />
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ZOOM BUTTON */}
//       <strong
//         className="Zoom_first_page d-flex justify-content-end"
//         style={{ cursor: "pointer" }}
//         data-bs-toggle="modal"
//         data-bs-target={"#" + apiend + "_modal"}
//       >
//         <BsZoomIn />
//       </strong>

//       <WaterMark />

//       {/* MAIN CHART */}
//       {isLoading ? (
//         <ChartLoader />
//       ) : chartdata.length > 1 ? (
//         <Chart
//           chartType="ColumnChart"
//           width="100%"
//           height="230px"
//           data={chartdata}
//           options={options}
//           chartEvents={[
//             {
//               eventName: "select",
//               callback: ({ chartWrapper }) => {
//                 const chart = chartWrapper.getChart();
//                 const selection = chart.getSelection();
//                 if (!selection.length) return;

//                 const barIndex = selection[0].row;
//                 const range = binRanges[barIndex];

//                 fetchData(
//                   {
//                     url: API_URL_MAIN + MAIN_ENDPOINT + CLICK_ENDPOINT,
//                     body: {
//                       filterdata: gloablfilter,
//                       coolantin_Option: tempCoolant,
//                       from_bucket: range.from,
//                       to_bucket: range.to
//                     }
//                   },
//                   appyDataClick
//                 );

//                 window.$("#exampleModal__" + apiend).modal("show");
//               }
//             }
//           ]}
//         />
//       ) : (
//         <NoData />
//       )}

//       {/* CLICK POPUP */}
//       <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1}>
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" />
//             </div>

//             <div className="modal-body">
//               <CommanBarTable_Orion
//                 data={toPushPopUp}
//                 tabDataKey={tempCoolant}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default CoolantInCycles_Orion;

import React, { useEffect, useState, useMemo } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData from "../../NoData";
import ChartLoader from "../../ChartLoader";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import CommanBarTable_Orion from "../CommanBarTable_Orion";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

let CoolantChartData;

function CoolantInCycles_Orion({
  apiend,
  gloablfilter,
  type,
  coolantin_Option,
  chartnameFCD,
  selectedPack = "A",
  coolantInOut = "In"
}) {
  const MAIN_ENDPOINT = "orion_charging_analysis/";
  const CLICK_ENDPOINT = "coolant_in_cycles_click";

  const [chartdata, setChartData] = useState([]);
  const { isLoading, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  const [tempCoolant, setTempCoolant] = useState("");

  let barcolor = "#3578b0";

  // Compose coolant option
  const composedCoolantOption = useMemo(() => {
    if (coolantin_Option && coolantin_Option.trim() !== "") {
      return coolantin_Option;
    }
    return `${selectedPack}_Coolant_Temp_${coolantInOut}`;
  }, [coolantin_Option, selectedPack, coolantInOut]);

  // BIN LABELS (unchanged)
  const binLabels = [
    "<20",
    "20–24",
    "24–28",
    "28–32",
    "32–36",
    "36–40",
    "40–44",
    "44–48",
    ">48"
  ];

  // BIN RANGES (unchanged)
  const binRanges = [
    { from: 0, to: 20 },
    { from: 20, to: 24 },
    { from: 24, to: 28 },
    { from: 28, to: 32 },
    { from: 32, to: 36 },
    { from: 36, to: 40 },
    { from: 40, to: 44 },
    { from: 44, to: 48 },
    { from: 48, to: 9999 }
  ];

  // ====================
  // MAIN DATA PROCESSING
  // ====================
  const appyDataCycles = (data) => {
    if (!data || data.length === 0) {
      setChartData([]);
      return;
    }

    let d = data[0];

    // 🔥 FIXED: BINS SORTING B1 → B9 (ONLY CHANGE DONE)
    let keys = Object.keys(d)
      .filter((k) => k.startsWith("B"))
      .sort((a, b) => Number(a.substring(1)) - Number(b.substring(1)));

    let googleChartArr = [["Element", "Count", { role: "style" }]];
    let labels = [];
    let datasetValues = [];

    keys.forEach((k, index) => {
      let label = binLabels[index] || k;

      let value =
        d[k] && typeof d[k].value === "number"
          ? d[k].value
          : (d[k] && d[k].value) || 0;

      labels.push(label);
      datasetValues.push(value);

      googleChartArr.push([
        label,
        value,
        "stroke-width: 1;stroke-color: black;"
      ]);
    });

    CoolantChartData = {
      labels,
      datasets: [
        {
          label: "Coolant Values",
          data: datasetValues,
          backgroundColor: barcolor,
          borderWidth: 1,
          borderColor: "black"
        }
      ]
    };

    setChartData(googleChartArr);
  };

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: { color: "white" },
        title: { display: true, text: "Coolant Temperature" },
        ticks: { autoSkip: false }
      },
      y: {
        grid: { color: "white" },
        title: { display: true, text: "Charging Cycles" }
      }
    },
    plugins: { legend: { display: false } }
  };

  const options = {
    hAxis: {
      gridlines: { color: "transparent" },
      title: "Coolant Temperature",
      slantedText: true,
      slantedTextAngle: 90
    },
    vAxis: {
      gridlines: { color: "transparent" },
      title: "Charging Cycles"
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    series: { 0: { color: "#3578b0" } }
  };

  useEffect(() => {
    setTempCoolant(composedCoolantOption);

    fetchData(
      {
        url: API_URL_MAIN + MAIN_ENDPOINT + apiend,
        body: {
          filterdata: gloablfilter,
          coolantin_Option: composedCoolantOption
        }
      },
      appyDataCycles
    );

    SetChartName(chartnameFCD || `Coolant Cycles - ${composedCoolantOption}`);
  }, [gloablfilter, type, composedCoolantOption, apiend]);

  // CLICK POPUP LOGIC (UNCHANGED)
  const [toPushPopUp, settoPushPopUp] = useState([]);

  const appyDataClick = (data) => {
    let arr = [];

    data.forEach((i) => {
      arr.push({
        key: {
          vehicleId: i.key.vehicleId,
          Depot_Name: i.key.Depot_Name,
          DLR_ORG_CITY: i.key.DLR_ORG_CITY,
          vehicle_registration_number: i.key.vehicle_registration_number
        },
        doc_count: i.doc_count,
        [tempCoolant]: {
          values: {
            "50.0": i.doc_count
          }
        }
      });
    });

    arr.sort((a, b) => {
      const av = a[tempCoolant]?.values?.["50.0"] || 0;
      const bv = b[tempCoolant]?.values?.["50.0"] || 0;
      return bv - av;
    });

    settoPushPopUp(arr);
  };

  return (
    <>
      {/* MODAL CHART */}
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
            </div>

            <div
              className="modal-body d-flex justify-content-center"
              style={{ height: "400px" }}
            >
              {isLoading ? (
                <ChartLoader />
              ) : chartdata.length > 1 ? (
                <Bar
                  options={options1}
                  data={CoolantChartData}
                  width="100%"
                  height="65px"
                />
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ZOOM BUTTON */}
      <strong
        className="Zoom_first_page d-flex justify-content-end"
        style={{ cursor: "pointer" }}
        data-bs-toggle="modal"
        data-bs-target={"#" + apiend + "_modal"}
      >
        <BsZoomIn />
      </strong>

      <WaterMark />

      {/* MAIN CHART */}
      {isLoading ? (
        <ChartLoader />
      ) : chartdata.length > 1 ? (
        <Chart
          chartType="ColumnChart"
          width="100%"
          height="230px"
          data={chartdata}
          options={options}
          chartEvents={[
            {
              eventName: "select",
              callback: ({ chartWrapper }) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                if (!selection.length) return;

                const barIndex = selection[0].row;
                const range = binRanges[barIndex];

                fetchData(
                  {
                    url: API_URL_MAIN + MAIN_ENDPOINT + CLICK_ENDPOINT,
                    body: {
                      filterdata: gloablfilter,
                      coolantin_Option: tempCoolant,
                      from_bucket: range.from,
                      to_bucket: range.to
                    }
                  },
                  appyDataClick
                );

                window.$("#exampleModal__" + apiend).modal("show");
              }
            }
          ]}
        />
      ) : (
        <NoData />
      )}

      {/* CLICK POPUP */}
      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
            </div>

            <div className="modal-body">
              <CommanBarTable_Orion
                data={toPushPopUp}
                tabDataKey={tempCoolant}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoolantInCycles_Orion;
